import { Navigation, SimpleOrdinance } from './types';

const ordinanceIndexDetails = (ordinance: Navigation): SimpleOrdinance => ({
  id: ordinance.ordinanceID,
  type: ordinance.ordinanceType,
  semanticNumber: ordinance.semanticNumber,
});

export { ordinanceIndexDetails };
